import { render, staticRenderFns } from "./pay-item2.vue?vue&type=template&id=b40e50fa&scoped=true&"
import script from "./pay-item2.vue?vue&type=script&lang=js&"
export * from "./pay-item2.vue?vue&type=script&lang=js&"
import style0 from "./pay-item2.vue?vue&type=style&index=0&id=b40e50fa&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40e50fa",
  null
  
)

export default component.exports